import React from 'react';

const LazyLoadingFallback: React.FC = () => (
  <div className="flex items-center justify-center min-h-[200px] w-full h-full">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
  </div>
);

export default LazyLoadingFallback;
